// Structured data for the document scanning section.
//
// Why this exists: Keyword Planner shows this niche is tiny (about 90-100
// bureau-intent searches a month across Brisbane and the Gold Coast), so we
// are not going to win it on volume. What we can win is the shape of the
// result: FAQ rich snippets against the questions Google already shows in
// "People also ask" for these queries - "How much does it cost to scan a box
// of documents?" is one of them - plus a clean Service entity tied to the two
// cities we actually serve.

const SITE = "https://www.hotsnail.com.au";

export const scanningService = ({
  name = "Document scanning services",
  description,
  path = "/document-scanning/",
  areas = ["Gold Coast", "Brisbane", "Queensland"],
}) => ({
  "@type": "Service",
  "@id": `${SITE}${path}#service`,
  name,
  description,
  serviceType: "Document scanning and digitisation",
  url: `${SITE}${path}`,
  provider: {
    "@type": "Organization",
    name: "HotSnail",
    url: SITE,
  },
  areaServed: areas.map((a) => ({
    "@type": "Place",
    name: a,
  })),
  audience: {
    "@type": "BusinessAudience",
    name: "Australian businesses with paper archives",
  },
});

export const breadcrumbs = (trail) => ({
  "@type": "BreadcrumbList",
  itemListElement: trail.map((item, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: item.name,
    item: `${SITE}${item.path}`,
  })),
});

// faqs: [{ q, a }] - `a` must be plain text, so keep the answer strings free
// of markup.
export const faqPage = (faqs) => ({
  "@type": "FAQPage",
  mainEntity: faqs.map(({ q, a }) => ({
    "@type": "Question",
    name: q,
    acceptedAnswer: {
      "@type": "Answer",
      text: a,
    },
  })),
});

export const offerCatalog = ({ path, items }) => ({
  "@type": "OfferCatalog",
  "@id": `${SITE}${path}#offers`,
  name: "Document scanning rates",
  itemListElement: items.map(({ name, price, unit, description }) => ({
    "@type": "Offer",
    name,
    description,
    priceCurrency: "AUD",
    price,
    priceSpecification: {
      "@type": "UnitPriceSpecification",
      price,
      priceCurrency: "AUD",
      unitText: unit,
    },
  })),
});

// For explainer pages that answer a question rather than sell a service.
export const guideArticle = ({ headline, description, path, published }) => ({
  "@type": "Article",
  "@id": `${SITE}${path}#article`,
  headline,
  description,
  url: `${SITE}${path}`,
  mainEntityOfPage: `${SITE}${path}`,
  datePublished: published,
  dateModified: published,
  author: { "@type": "Organization", name: "HotSnail", url: SITE },
  publisher: { "@type": "Organization", name: "HotSnail", url: SITE },
});
